module.exports = __webpack_public_path__ + "img/graphics-2.5cd4cce8.svg";